import { render } from "./GreetingDialog.vue?vue&type=template&id=97819af0&scoped=true"
import script from "./GreetingDialog.vue?vue&type=script&lang=js"
export * from "./GreetingDialog.vue?vue&type=script&lang=js"

import "./GreetingDialog.vue?vue&type=style&index=0&id=97819af0&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97819af0"]])

export default __exports__